<rds-form-field labelPosition="floating" [id]="elementID()">
  <rds-control-label>{{ label() }}</rds-control-label>
  <rds-multi-autocomplete
    [options]="options"
    [formControl]="control()"
    [displayProperty]="displayFormatter"
    [highlightQuery]="true"
    placeholder="Type anything to search..."
    minSearchChars="0"
    debounce="0"
    multiMinimumInputWidth="125"
  />
</rds-form-field>
